export const orderSteps = [
  { value: "ordered", label: "Commandé", color: "#FF4747" },
  { value: "preparing", label: "En préparation", color: "orange" },
  { value: "ready-for-delivery", label: "Prête pour la livraison", color: "purple" },
  { value: "delivering", label: "En cours de livraison", color: "cyan" },
  { value: "delivered", label: "Livré", color: "green" },
];
export const formatDateFr = (date) => '1/1/1';
export const isImage = () => true;
export const formatAmount = (value) =>
  new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(value);